import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00700291"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["BaseInput"], {
      ref: "baseInput",
      label: $props.label,
      name: $props.name,
      type: $setup.inputType,
      placeholder: "비밀번호를 한번 더 입력하세요",
      errorMessage: $props.errorMessage,
      enableClearText: $props.enableClearText,
      value: $setup.inputValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
      rules: $props.rules,
      required: $props.required
    }, {
      inputInnerButton: _withCtx(() => [
        ($props.showToggleBtn)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img-toggle-show",
              src: $setup.toggleImage,
              onClick: $setup.toggleShowPassword,
              role: "button",
              "aria-label": "비밀번호 표시 토글"
            }, null, 8 /* PROPS */, _hoisted_1))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "name", "type", "errorMessage", "enableClearText", "value", "rules", "required"])
  ]))
}